import { useQuery } from "@tanstack/react-query";
import { api } from "../api/api";
import { QUERY_KEYS } from "./queryKeys";

export function useEndpoints(projectId: string | undefined) {
  return useQuery({
    queryKey: [QUERY_KEYS.ENDPOINTS, projectId],
    queryFn: () => {
      if (!projectId) {
        throw new Error("projectId is required");
      }
      return api.getEndpoints(projectId);
    },
    enabled: !!projectId,
    staleTime: 5 * 60 * 1000, // 5 minutes
    gcTime: 10 * 60 * 1000, // 10 minutes
  });
}
